import React from "react";

const ScrollableComponent = ({ children, height }) => {
  const style = {
    height: height || "100px",
    overflowY: "auto",
    border: "1px solid #ccc",
  };

  return <div style={style}>{children}</div>;
};

export default ScrollableComponent;

